// extracted by mini-css-extract-plugin
export var socialButton = "socialButton-module--socialButton--0618b";
export var tooltip = "socialButton-module--tooltip--5b962";